export const isMobileProbably = () => (
  /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
  (navigator.platform && /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform))
)

export const isTouchDevice = () => (
  ('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0)
)